import React from 'react';
import { HeaderBar } from '../layout/header/headerbar/HeaderBar';
import { Footer } from '../layout/footer/Footer';

export const Layout = ({ children }) => {

    return (
        <div>
            <HeaderBar />
            <div>{children}</div>
            <Footer />
        </div>
    );
}
